let LOCALHOST_CONFIG = {
    HOST_URL: 'http://localhost:18000/',
};

let DEV_CONFIG = {
    HOST_URL: 'https://duo.dev.tuecede.de/',
};

let PROD_CONFIG = {
  HOST_URL: "/"
}


let config = PROD_CONFIG;

export default config;
